export const checkPermission = (permissions, action) =>
	permissions?.some((permission) => permission.name === action && permission.authorized);
